import { Container, Grid } from '@mui/material';
import './App.css';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Profile from './components/Profile/Profile';
import Portfolio from './pages/Portfolio/Portfolio';
import Resume from './pages/Resume/Resume';
import {BrowserRouter,Routes, Route} from 'react-router-dom';

function App() {
  return (
    <Container className='margin'>
      <Grid container spacing={7}>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Profile/>
        </Grid>    
        <Grid item lg md sm={12} xs={12}>
          <BrowserRouter>
          <Header/>
          <div className='main_container container_shadow'>  
            <Routes>
            <Route path='/portfolio' element={<Portfolio/>} />
            <Route path='/' element={<Resume/>} />
          </Routes>
          </div>
          </BrowserRouter>
          <Footer/>
        </Grid>
      </Grid>
    </Container>
  );
}

export default App;
